export enum DiscountTypes {
    ABSOLUTE = 'ABSOLUTE',
    PERCENTAGE = 'PERCENTAGE'
}
